import { render, staticRenderFns } from "./CommentBoxLinkEmbed.vue?vue&type=template&id=86e920d6&scoped=true"
import script from "./CommentBoxLinkEmbed.vue?vue&type=script&lang=js"
export * from "./CommentBoxLinkEmbed.vue?vue&type=script&lang=js"
import style0 from "./CommentBoxLinkEmbed.vue?vue&type=style&index=0&id=86e920d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86e920d6",
  null
  
)

export default component.exports